import { Flex, Heading, Text, VStack } from '@chakra-ui/react';
import { FC } from 'react';
import { ChecklistItem } from '../utils/buildChecklistItems';
import { ChecklistItemRow } from './ChecklistItemRow';

interface NeedsReviewChecklistProps {
  items: ChecklistItem[];
  /** The active checklist item's id (the item containing the selected tab). */
  activeItemId?: string;
  /** Selects a checklist item by opening its first document tab. */
  onSelectDocument: (ingestionDocumentId: string) => void;
}

/**
 * Left-rail "Needs review" section: the SkySlope checklist items that still
 * need the agent's review, shown directly (no folder/activity grouping) as a
 * flat selectable list with a count badge. Renders nothing when empty.
 */
export const NeedsReviewChecklist: FC<NeedsReviewChecklistProps> = ({
  items,
  activeItemId,
  onSelectDocument,
}) => {
  if (items.length === 0) {
    return null;
  }

  return (
    <VStack align="stretch" spacing={4}>
      <Flex align="center" gap={1.5} px={2.5}>
        <Heading
          color="compliance.text.primary"
          fontSize="md"
          fontWeight="semibold"
          size="headline"
        >
          Needs review
        </Heading>
        <Flex
          align="center"
          bg="whiteAlpha.100"
          borderRadius="6px"
          justify="center"
          px={2}
          py={0.5}
        >
          <Text color="compliance.status.warning" fontSize="sm">
            {items.length}
          </Text>
        </Flex>
      </Flex>

      <VStack align="stretch" spacing={1.5}>
        {items.map((item) => (
          <ChecklistItemRow
            key={item.id}
            isSelected={item.id === activeItemId}
            title={item.title}
            onSelect={() => onSelectDocument(item.docs[0].ingestionDocumentId)}
          />
        ))}
      </VStack>
    </VStack>
  );
};
